import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function useGetGroup(id?: number, enabled = true) {
  const getGroupQuery = useQuery({
    queryKey: [GroupKey.GROUP, id],
    queryFn: () => GroupService.getGroup(id).then((response) => response.data),
    enabled: enabled && !!id,
  });
  const errorMessage = useErrorMessage(getGroupQuery.error, baseErrorMessages);
  return { ...getGroupQuery, errorMessage };
}
